import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
    },
    thumb: {
        position: 'absolute',
        backgroundColor: '#FFFFFF',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        elevation: 2,
    },
});

export const defaultColors = {
    active: '#FF3B30',
    inactive: '#E5E5EA',
    thumb: '#FFFFFF',
};

export const defaultSizes = {
    width: 51,
    height: 31,
    thumbSize: 27,
    thumbMargin: 2,
};
